import { render } from "./AddPack.vue?vue&type=template&id=dc2a89e6"
import script from "./AddPack.vue?vue&type=script&lang=js"
export * from "./AddPack.vue?vue&type=script&lang=js"

import "./AddPack.vue?vue&type=style&index=0&id=dc2a89e6&lang=css"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__